/** URLs (http/https) im Freitext klickbar machen — sicher: nur Text-Splitting, kein HTML-Inject.
 *  Genutzt vom Dashboard-Block „Fehlende Unterlagen" und vom Mail-Monitor-Posteingang. */
export function linkifyMail(text: string) {
  return text.split(/(https?:\/\/[^\s]+)/g).map((part, i) => {
    if (i % 2 === 0) return part;
    const trail = part.match(/[.,;:!?)\]}'"]+$/)?.[0] ?? '';
    const url = trail ? part.slice(0, part.length - trail.length) : part;
    return (
      <span key={i}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="text-blue-600 dark:text-blue-400 underline break-all"
        >
          {url}
        </a>
        {trail}
      </span>
    );
  });
}
